import React from 'react';
import { FormGroup, HelpBlock } from 'react-bootstrap';
import { InputFieldLoader } from '../input-field-loader';

export const InputAsyncField = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched },
  label,
  type,
  isLoading = false,
  disabled,
  placeholder,
  showLabel = true,
  labelCol,
  ...props
}) => {
  const { className, ...rest } = props

  return (
    <div className="row">
      {showLabel && (
        <div className= {`${labelCol || "col-lg-4"} col-form-label`}>
          <p className="profile-label">{label}</p>
        </div>
      )}
      <div className={'col-lg-12'}>
        <FormGroup
          controlId={name}
          validationState={touched[name] && errors[name] ? 'error' : null}
        >
          <input
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            disabled={disabled}
            onBlur={onBlur}
            placeholder={placeholder}
            className="profile-input form-control"
            autoComplete="off"
            {...rest}
          />

          <InputFieldLoader isLoading={isLoading} />

          <HelpBlock>{touched[name] && errors[name]}</HelpBlock>
        </FormGroup>
      </div>
    </div>
  );
};
